import React from 'react';

const SuggestList = ({ suggestions, focusIndex, onSuggestionClick, type }) => {
    return (
        <div className={`p-suggestion s-suggestion s-suggestion--${type} is-on`}>
            <ul className="p-suggestion_inner">
                {suggestions.map((suggestion, index) => (
                    <li key={suggestion}>
                        <a
                            href=""
                            id={type === 'location' && index === 0 ? 's-firstSuggest' : undefined}
                            className={`p-suggestion_link p-suggestion_icon--${type === 'keyword' ? 'kw' : type} s-suggestion--${type}_item ${
                                focusIndex === index ? 'is-focus' : ''
                            }`}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onSuggestionClick(suggestion);
                            }}
                            tabIndex="-1"
                            rel="nofollow"
                        >
                            {suggestion}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SuggestList;
